import addDays from "date-fns/addDays";
import moment from "moment";
import { getAuthData } from "../../services/AuthService";


export interface iInvoiceFilter {
    InvoiceNo: string;
    CustomerID: number;
    From: string;
    To: string;
    StaffID: number;
    Region: string;
    IsProforma: boolean;
    readonly Reader: string;
}

export class InvoiceFilter {
    InvoiceNo: string;
    CustomerID: number;
    From: string;
    To: string;
    StaffID: number;
    Region: string;
    IsProforma: boolean;
    readonly Reader: string;

    constructor();
    constructor(obj: iInvoiceFilter);	
    constructor(obj?: iInvoiceFilter) { 
        this.InvoiceNo = obj?.InvoiceNo ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.StaffID = obj?.StaffID ?? 0;
        this.Region = obj?.Region ?? "ALL";
        this.IsProforma = obj?.IsProforma ?? false;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}

export interface iInvoiceHistoryFilter {
    SearchString: string;
    CustomerID: number;
    EndUserID: number;
    readonly Reader: string;
}

export class InvoiceHistoryFilter {
    SearchString: string;
    CustomerID: number;
    EndUserID: number;
    readonly Reader: string;

    constructor();
    constructor(obj: iInvoiceHistoryFilter);	
    constructor(obj?: iInvoiceHistoryFilter) { 
        this.SearchString = obj?.SearchString ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.EndUserID = obj?.EndUserID ?? 0;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}